import React from "react"
import styled, { css } from "styled-components"

import { useSoundEffect } from "/src/hooks"
import { FLEX_VARIANTS } from "/src/constants"
import Swoosh from "/media/swoosh.mp3"
import FlexFace from "/src/components/flex/FlexFace"

const Username = styled.span`
  font-size: 2rem;
  
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`
const Score = styled.span`
  font-size: ${({length}) => (
    1.7
  )}rem;
`

const Rank = styled.span`
  margin: auto;
  font-size: ${({length}) => (
    length > 4 
      ? 1.3 :
    length > 3 
      ? 1.5 :
    length > 2 
      ? 1.9 :
    2.1
  )}rem;
`

const contentCentered = css`
  display: flex;
  align-items: center;
  justify-content: center;
`
const nudgeUp = css`
  position: relative;
  top: -0.1rem;
`

const Bars = styled.div`
  position: relative;
  left: -4rem;
`
const UsernameBar = styled.div`
  ${contentCentered}

  height: 3.5rem;

  color: white;
  background-color: ${props => props.color};

  border-radius: 50px;
  padding: 0rem 2rem 0rem 4.5rem;

  overflow: hidden;
  min-width: 11rem;
  max-width: 18rem;
  position: relative;
  z-index: 2;
`
const ScoreBar = styled.div`
  ${contentCentered}
  ${nudgeUp}

  height: 2.6rem;

  color: black;
  background-color: ${props => props.color};

  border-radius: 0 0 17px 17px;
  padding: 0rem 2rem 0rem 4rem;

  width: 60%;
  white-space: nowrap;
  justify-content: center;
`
const RankCircle = styled.div`
  ${contentCentered}

  height: 6rem;
  width: 6rem;

  color: ${props => props.color};
  background-color: white;

  border-radius: 100px;

  font-weight: bold;
  position: relative;
  white-space: nowrap;
  z-index: 3;
`
const Container = styled.div`
  display: flex;
  align-items: center;
  height: min-content;
  font-family: "Myriad Pro";
  transform: scale(1.25);
  transform-origin: top left;
`
const Flex = ({color, disableAnimation, username, score, rank}) => {

  const { colors } = FLEX_VARIANTS[color]

  return (
    <Container>
      <FlexFace
        color={color}
        isAnimated={!disableAnimation}
      />
      <RankCircle color={colors.main}>
        <Rank length={rank.toString().length}>
          #{rank}
        </Rank>
      </RankCircle>
      <Bars>
        <UsernameBar color={colors.dark}>
          <Username length={username.length}>
            {username}
          </Username>
        </UsernameBar>
        <ScoreBar color={colors.main}>
          <Score length={score.length}>
            Punkte: {parseInt(score).toLocaleString()}
          </Score>
        </ScoreBar>
      </Bars>
    </Container>
  )
}

export default React.memo(Flex)
